<template>
  <!-- Origem Flow: bloco de código do editor de docs. Quando a linguagem é
       "mermaid", renderiza o diagrama ao vivo abaixo do código-fonte. -->
  <NodeViewWrapper class="doc-code-block">
    <pre
      class="doc-code-block__source"
    ><NodeViewContent as="code"></NodeViewContent></pre>
    <div v-if="isMermaid" class="doc-code-block__preview">
      <div v-if="error" class="doc-code-block__error">
        <i class="iconoir-warning-triangle"></i> {{ error }}
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-else-if="svg" class="doc-code-block__diagram" v-html="svg"></div>
      <div v-else class="doc-code-block__hint">
        {{ $t('docCodeBlock.mermaidHint') }}
      </div>
    </div>
  </NodeViewWrapper>
</template>

<script>
import { NodeViewContent, NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3'

import { uuid } from '@baserow/modules/core/utils/string'

export default {
  name: 'DocCodeBlock',
  components: { NodeViewWrapper, NodeViewContent },
  props: nodeViewProps,
  data() {
    return {
      svg: '',
      error: null,
      renderTimeout: null,
    }
  },
  computed: {
    isMermaid() {
      return (this.node.attrs.language || '').toLowerCase() === 'mermaid'
    },
    source() {
      return this.node.textContent
    },
  },
  watch: {
    source: {
      handler() {
        this.scheduleRender()
      },
      immediate: true,
    },
    isMermaid() {
      this.scheduleRender()
    },
  },
  beforeUnmount() {
    clearTimeout(this.renderTimeout)
  },
  methods: {
    scheduleRender() {
      if (!this.isMermaid) {
        return
      }
      clearTimeout(this.renderTimeout)
      this.renderTimeout = setTimeout(() => this.render(), 600)
    },
    async render() {
      const source = this.source.trim()
      if (source === '') {
        this.svg = ''
        this.error = null
        return
      }
      try {
        // Carregada sob demanda: só entra no bundle da página quando um
        // diagrama existe de fato.
        const mermaid = (await import('mermaid')).default
        const lightTheme =
          document.documentElement.classList.contains('light-theme')
        mermaid.initialize({
          startOnLoad: false,
          securityLevel: 'strict',
          theme: lightTheme ? 'default' : 'dark',
        })
        const { svg } = await mermaid.render(`mermaid-${uuid()}`, source)
        this.svg = svg
        this.error = null
      } catch (error) {
        // Fonte inválida durante a digitação: mantém o último diagrama bom
        // e mostra o erro discreto.
        this.error = String(error?.message || error).split('\n')[0]
      }
    },
  },
}
</script>
